import React from "react";
import { Route, Router, Switch } from "wouter";
import WarrantyList from "../admin/screens/warranties/warranties-list";
import QRCodesList from "../admin/screens/QRCodes/qr-codes-list";
import WarrantyDetails from "../admin/screens/warranties/warranty-details";
import ExcelUpload from "../admin/screens/QRCodes/excel-upload";
import QRCodesListNorth from "../admin/screens/QRCodes/qr-codes-north";
import QRCodesListWest from "../admin/screens/QRCodes/qr-codes-west";

const ErrorScreen = React.lazy(() => import("../404"));

const AdminRoutes = () => {
  return (
    <Router>
      <React.Suspense>
        <Switch>
          <Route path="/admin/warranties" component={WarrantyList} />
          <Route path="/" component={WarrantyList} />
          <Route path="/admin/qr-codes-ncr" component={QRCodesList} />
          <Route path="/admin/qr-codes-north" component={QRCodesListNorth} />
          <Route path="/admin/qr-codes-west" component={QRCodesListWest} />
          <Route
            path="/admin/warranty-details/:warrantyId"
            component={WarrantyDetails}
          />
          <Route path="/admin/excel-upload" component={ExcelUpload} />
          <Route component={ErrorScreen} />
        </Switch>
      </React.Suspense>
    </Router>
  );
};

export default AdminRoutes;
